module.exports = __webpack_public_path__ + "img/Banner.1b9aa67d.svg";